import { render, staticRenderFns } from "./deadline.vue?vue&type=template&id=478cefc1&"
import script from "./deadline.vue?vue&type=script&lang=js&"
export * from "./deadline.vue?vue&type=script&lang=js&"
import style0 from "./deadline.vue?vue&type=style&index=0&id=478cefc1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports